import type { Domain } from '@/config/domain/type';

export const trademarksOnlineHongKong: Domain = {
    domain: import.meta.env.VITE_TMO_HK_DOMAIN,
    website: 'https://www.trademarksonline.hk',
    shortCode: 'TMO-HK',
    markSource: '',
    title: 'Apply for your Hong Kong trademark',
    name: 'Trademarks Online Hong Kong',
    description: 'Our online trademark registration platform is available 24/7 and takes just minutes. Apply for your Hong Kong trademark by entering your trademark or logo.',
    logo: '/img/TM-Logo-White-Thin.png',
    menuItems: [
        { label: 'Home', url: '' },
        { label: 'Pricing', url: '/pricing' },
        { label: 'FAQ', url: '/trademark-questions' },
        { label: 'About', url: '/about-us' },
    ],
    footerItems: [
        { label: 'Privacy Policy', url: '/privacy-policy' },
        { label: 'Terms of Use', url: '/terms-of-use' },
        { label: 'Contact Us', url: '/contact' },
    ],
    termOfUseUrl: '/terms-of-use',
    bannerImageUrl: '',
    gtmId: 'GTM-5MSFXTNV',
};
